import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
// import { API_URL } from '../../config/config';

const API_URL = process.env.REACT_APP_API_URL;

// Utility to get the token
const getAuthToken = (getState) =>
  (getState && getState().auth && getState().auth.token) ||
  sessionStorage.getItem("access_token") ||
  localStorage.getItem("access_token");

// Async thunk to fetch all admins
export const fetchAllAdmins = createAsyncThunk(
  'admins/fetchAllAdmins',
  async (_, { rejectWithValue, getState }) => {
    try {
      const token = getAuthToken(getState);
      const response = await axios.get(`${API_URL}/users/admins`, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });
      console.log('Fetched admins:', response.data); // Debug fetched data
      return response.data;
    } catch (error) {
      console.error('Failed to fetch admins:', error); // Log error for debugging
      return rejectWithValue(error.response?.data || 'Failed to fetch admins');
    }
  }
);

export const updateAdmin = createAsyncThunk(
  'admins/updateAdmin',
  async ({ adminId, adminData }, { rejectWithValue, getState }) => {
    try {
      const token = getAuthToken(getState);
      const response = await axios.put(`${API_URL}/users/updateAdmin/${adminId}`, adminData, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });
      return response.data;
    } catch (error) {
      console.error('failed to update admin:', error);
      return rejectWithValue(error.response?.data || 'failed to update admin');
    }
  }
);

export const deleteAdmin = createAsyncThunk(
  'admins/deleteAdmin',
  async (adminId, { rejectWithValue, getState }) => {
    try {
      const token = getAuthToken(getState);
      const response = await axios.delete(`${API_URL}/user/deleteAdmin/${adminId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });
      return response.data;
    } catch (error) {
      console.error('failed to delete admin:', error);
      return rejectWithValue(error.response?.data || 'failed to delete admin');
    }
  }
);

// Create the admins slice
const adminSlice = createSlice({
  name: 'admin',
  initialState: {
    admins: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearAdmins: (state) => {
      state.admins = [];
      state.error = null;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllAdmins.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllAdmins.fulfilled, (state, action) => {
        state.loading = false;
        state.admins = action.payload;
      })
      .addCase(fetchAllAdmins.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateAdmin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateAdmin.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.admins.findIndex(admin => admin.admin_id === action.payload.admin_id);
        if (index !== -1) {
          state.admins[index] = action.payload;
        }
      })
      .addCase(updateAdmin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteAdmin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteAdmin.fulfilled, (state, action) => {
        state.loading = false;
        state.admins = state.admins.filter(admin => admin.admin_id !== action.payload.admin_id);
      })
      .addCase(deleteAdmin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// Export actions and reducer
export const { clearAdmins } = adminSlice.actions;
export default adminSlice.reducer;



// import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import axios from 'axios';
// // import { API_URL } from '../../config/config';

// const API_URL = process.env.REACT_APP_API_URL;


// // Async thunk to fetch all users
// export const fetchAllAdmins = createAsyncThunk(
//   'admins/fetchAllAdmins',
//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await axios.get(`${API_URL}/users/admins`);
//       console.log('Fetched admins:', response.data); // Debug fetched data
//       return response.data;
//     } catch (error) {
//       console.error('Failed to fetch admins:', error); // Log error for debugging
//       return rejectWithValue(error.response?.data || 'Failed to fetch admins');
//     }
//   }
// );
// export const updateAdmin = createAsyncThunk(
//   'admins/updateAdmin',
//   async({adminId,adminData},{rejectwithvalue}) =>{
//     try{
//       const response = await axios.put(`${API_URL}/users/updateAdmin/${adminId}`,adminData);
//       return response.data;
//     } catch (error) {
//       console.error('failed to update admin:',error);
//       return rejectwithvalue(error.response?.data||'failed to update admin');
//     }
//   }
// );

// export const deleteAdmin = createAsyncThunk(
//   'admins/deleteAdmin',
//   async(adminId,{rejectwithvalue}) =>{
//     try{
//       const response = await axios.delete(`${API_URL}/user/deleteAdmin/${adminId}`);
//       return response.data;
//     } catch (error) {
//       console.error('failed to delete admin:',error);
//       return rejectwithvalue(error.response?.data||'failed to delete admin');
//     }
//   }
// );


// // Create the users slice
// const adminSlice = createSlice({
//   name: 'admin',
//   initialState: {
//     admins: [],       // List of users
//     loading: false,  // Indicates loading state
//     error: null,     // Stores any errors
//   },
//   reducers: {
//     clearAdmins: (state) => {
//       state.admins = []; // Clears the user data
//       state.error = null;
//       state.loading = false;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchAllAdmins.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchAllAdmins.fulfilled, (state, action) => {
//         state.loading = false;
//         state.admins = action.payload; // Store fetched users
//       })
//       .addCase(fetchAllAdmins.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload; // Capture error message
//       })
//       /* update user */
//       .addCase(updateAdmin.pending,(state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(updateAdmin.fulfilled, (state, action) => {
//         state.loading = false;
//         const index = state.admins.findIndex(admin => admin.admin_id === action.payload.admin_id);
//         if (index !== -1) {
//           state.admins[index] = action.payload;
//       }})
//       .addCase(updateAdmin.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       })
//       .addCase(deleteAdmin.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(deleteAdmin.fulfilled, (state, action) => {
//         state.loading = false;
//         state.admins = state.admins.filter(admin => admin.admin_id !== action.payload.admin_id);
//       })
//       .addCase(deleteAdmin.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       });
//   },
// });

// // Export actions and reducer
// export const { clearAdmins } = adminSlice.actions;
// export default adminSlice.reducer;
